var t = /* @__PURE__ */ ((e) => (e.Fixed = "fixed", e.Flexible = "flexible", e))(t || {});
const i = /* @__PURE__ */ Symbol(
  "setActiveTab"
), b = /* @__PURE__ */ Symbol("variant");
export {
  t as VariantsEnum,
  i as setActiveTabKey,
  b as variantKey
};
